export default __webpack_public_path__ + "static/media/icon-camera.a719b3a4.svg";